<template lang="pug">
form-item-wrapper(v-bind="bind", :showMessage="false", :rules="myRules")
  .el-input(:class="inputClass")
    .el-input__inner.loading(v-if="loading")
      i.el-icon-loading
      | 加载中...
    .el-input__inner(v-else, @click="onListClick")
      el-tag(v-for="{ deptId, deptName } in formatDeptList", :key="deptId", size="small", :closable="isEdit", @close="removeUser(deptId)") {{ deptName }}
      i.clear-all.el-icon-close(v-if="isEdit", title="重置", @click.stop="clearAll")
</template>
<script>
import { staticMixins, mapVFAssignField, cloneDeep, formInputMixins } from "@/CommonDP/VForm/utils";
import { DEPT_ENUM } from "./index.js";
import service from "@/CommonDP/service/login-service.js";
import { openMember, openH5Member } from "@/CommonDP/components/chooseMember/leftCom.js";
const _dept_catch = {};
export default {
  components: {},
  mixins: [staticMixins, formInputMixins],
  inheritAttrs: false,
  data() {
    return {
      template: { visible: false },
      rules: [],
      userDeptList: []
    };
  },
  computed: {
    ...mapVFAssignField({ deptIds: "mapDeptIdsTo", deptNames: "mapDeptNamesTo", fullNames: "mapFullNamesTo" }),
    loading() {
      return false;
    },
    formatDeptList() {
      return this.fieldModel;
    },
    vmDefaultValue() {
      const {
        userDeptList,
        options: { defaultDept, defaultDeptType }
      } = this;
      let temList;
      switch (defaultDeptType) {
        case DEPT_ENUM.all:
          temList = defaultDept;
          break;
        case DEPT_ENUM.cur_main:
          temList = (userDeptList || []).filter(({ isMain }) => isMain);
          break;
        default:
          temList = userDeptList;
          break;
      }
      return this.formatDeptToValue(temList);
    },
    myRules() {
      return [
        ...this.rules,
        {
          type: "array",
          required: this.options.required,
          message: this.options.requiredHint
        },
        {
          type: "array",
          max: this.options.max,
          min: this.options.min,
          message: "数量不符合要求"
        }
      ];
    },

    idStr() {
      const { fieldModel: value } = this;
      if (Array.isArray(value)) {
        return value.map(({ deptId }) => deptId).join(",");
      } else {
        return value;
      }
    }
  },
  watch: {
    fieldModel: {
      immediate: true,
      handler: "withUpdate"
    }
  },
  mounted() {
    this.initUserDept();
  },
  methods: {
    // 按照当前数据格式化数据
    formatDeptToValue(value) {
      const list = value || [];
      return cloneDeep(list).map(({ deptId, deptName, fullDeptName }) => ({ deptId, deptName, fullDeptName }));
    },
    async initUserDept() {
      const {
        enterpriseId,
        userId,
        options: { defaultDeptType }
      } = this;
      const key = `${enterpriseId}+${userId}`;
      const cache = _dept_catch[key] || service.queryCurrentUserDeptList({ enterpriseId });
      _dept_catch[key] = cache;
      const { data } = await cache;
      this.userDeptList = data;
      if (defaultDeptType !== DEPT_ENUM.all) {
        const defaultValue = this.formatDeptToValue(this.vmDefaultValue);
        if (!this.idStr) {
          this.forceSetValue(defaultValue);
        }
      }
    },
    clearAll() {
      this.preventDesign();
      this.updateValue([]);
      this.emitValidate();
    },
    async open() {
      this.preventPreview();
      this.preventDesign();
      const { formatDeptList: list = [], options: { single, max }} = this;
      const openDept = this.isH5 ? openH5Member : openMember;
      const _data = await openDept({
        codePri: ["Dept"],
        max: single ? 1 : max,
        usersList: list.map(({ deptId, deptName }) => ({
          id: deptId,
          nodeId: deptId,
          name: deptName,
          deptId,
          deptName,
          selectName: deptName,
          selectCode: "Dept"
        }))
      });
      const data = _data.map(({ id, name }) => ({ deptId: id, deptName: name }));
      this.updateValue(data);
      this.emitValidate();
    },
    onListClick() {
      if (this.isEdit) {
        this.open();
      }
    },
    async removeUser(id) {
      this.preventDesign();
      const { fieldModel } = this;
      if (!fieldModel || !fieldModel.length) {
        return;
      }
      const list = fieldModel.filter((item) => item.deptId !== id);
      this.updateValue(list);
      this.emitValidate();
    },
    // 触发form数据更新
    updateValue(value) {
      this.fieldModel = this.formatDeptToValue(value);
    },
    async withUpdate(value) {
      const deptList = value || [];
      await this.$nextTick();
      this.deptIds = deptList.map((item) => item.deptId).join(",");
      this.deptNames = deptList.map((item) => item.deptName).join(",");
      this.fullNames = deptList.map((item) => item.fullDeptName).join(",");
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
